import React, {useState} from "react";
import "styles/scss/login.scss";
import * as EgovNet from 'api/fetch';
import { getSessionItem } from "utils/storage";
import { useNavigate } from "react-router-dom";

function Account() {

    // 세션값 가져오기
    const sessionUser = getSessionItem('loginUser'); // 세션 값 확인

    const userId = sessionUser.id; // 세션값에서 userId 가져오기
    
    // 세션값 id에 넣어주기
    const [id, setId] = useState(userId);
    const [password, setPassword] = useState(''); // 비밀번호 상태 추가

    const navigate = useNavigate();

    const modifyBtnHandler = () => {
        console.log("Modifying user...");
        const modifyUrl = "/api/updateUser";
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify({userId: id, userPswd: password})
        };
        EgovNet.requestFetch(modifyUrl, requestOptions, (resp) => {
            if (resp.resultCode === 200) {
                alert("수정되었습니다.");
            } else {
                alert("수정에 실패하였습니다.");
            }
        });
    };

    const cancleHandler = () => {
        // 취소 버튼 클릭 시 로그인 페이지로 이동
        navigate('/psts');
    }

    return (
        <div className="login-container">
            <form className="login-box"
                onSubmit={(e) => e.preventDefault()} // 기본 동작 방지
            >
                <div className="box-tit">계정관리</div>
                <ul>
                    <li className="li-flex">
                        <span className="id-icon">아이디</span>
                        <label htmlFor="id" className="visually-hidden">아이디</label>
                        <input
                            type="text" id="id" name="id"
                            className="form-control login-form"
                            defaultValue={id}
                            onChange={(e) => setId(e.target.value)}
                        />
                    </li>
                    <li className="li-flex">
                        <span className="password-icon">새 비밀번호</span>
                        <input
                            type="password" id="password" name="password"
                            className="form-control login-form"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </li>
                    <li>
                        <button type="submit" className="btn edit-btn" onClick={modifyBtnHandler}>수정</button>
                    </li>
                    <li>
                        <button type="submit" className="btn cancle-btn" onClick={cancleHandler}>취소</button>
                    </li>
                </ul>
                <div className="bg"></div>
            </form>
        </div>
    );
}

export default Account;
